import { Component, Inject, OnDestroy,HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivationService } from '../../services/activation.service';
import { OverlayContainer } from '@angular/cdk/overlay';
@Component({
  selector: 'dialog-data-example-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ViewActivationConfirmationDialog implements OnInit {

  public ActivationsArray: any;
  public isDataPresent:boolean = false;
  public noAttaActivationsArray:any;
  NewSavedActivations: any;
  SavedActivations: any;
  deleteMessage:any;
  siftLocked :boolean;
  CRcomment = '';
  driverOptions: { label: string; value: string; description: string }[] = [];
  selectedDriver: string = '';
  selectedDriverLabel: string = '';
  driverComment: string = '';
  isDriverLoading: boolean = false;
  isDropdownOpen: boolean = false;
  driverTouched: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _snackBar:MatSnackBar,
    private overlayContainer: OverlayContainer,
    private dialogRef: MatDialogRef<ViewActivationConfirmationDialog>,
    private service: ActivationService
  ) {
    this.ActivationsArray       = data.activationWbs;
    this.SavedActivations       = data.Savedactivations;
    this.NewSavedActivations    = data.NewActivations;
    this.deleteMessage          = data.deleteMessage;
    this.noAttaActivationsArray = data.noAttaActArray;
    this.siftLocked             = data.enablePopUp === true ? data : false;
  }

  ngOnInit(): void {
    // Fetch drivers for BOTH: CR flow AND standalone driver flow
    if (this.data?.changeReqList?.length > 0 || this.data?.showDriverSection) {
      this.fetchDriverOptions();
    }
  }

  /** True when dialog is opened ONLY for driver selection (draft / new project). */
  get isStandaloneDriverMode(): boolean {
    return !!this.data?.showDriverSection && !(this.data?.changeReqList?.length > 0);
  }

  // ── Dropdown handlers ──
  toggleDropdown(): void {
    if (this.isDriverLoading) { return; }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectDriver(driver: any): void {
    this.selectedDriver      = driver.value;
    this.selectedDriverLabel = driver.label;
    this.driverTouched       = true;
    this.isDropdownOpen      = false;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.custom-dropdown')) {
      this.isDropdownOpen = false;
    }
  }

  onRetryDrivers(): void {
    this.fetchDriverOptions();
  }

  fetchDriverOptions(): void {
    this.isDriverLoading = true;
    this.service.getDriverDropdown().subscribe({
      next: (response: any) => {
        this.driverOptions = (response || []).map((item: any) => ({
          label      : item.label,
          value      : item.code,
          description: item.description
        }));
        this.isDriverLoading = false;
      },
      error: (err: any) => {
        console.error('Error fetching driver options', err);
        this._snackBar.open('Failed to load driver options', 'X');
        this.isDriverLoading = false;
      }
    });
  }

  close() {}

  onProceed(): void {

    // check whether CR comment and Driver is selected (Change Request)
    if (this.data.changeReqList?.length > 0) {
      if (!this.CRcomment?.length) {
        this._snackBar.open('Please enter a comment prior to submitting the change request', 'X');
        return;
      }
      if (this.data?.showDriverSection && !this.selectedDriver) {
        this.driverTouched = true;
        this._snackBar.open('Please select a driver before proceeding', 'X', { duration: 3000 });
        return;
      }

      const CrComment: any = {
        CRcomment    : this.CRcomment,
        wbs          : this.data.changeReqList,
        driverCode   : this.selectedDriverLabel,       
        driverComment: this.driverComment ?? ''
      };
      this.service.setCRcomment(CrComment);
      this.dialogRef.close(true);
      return;
    }

    //Check whether DR is selected (draft / newly created project)
    if (this.isStandaloneDriverMode) {
      if (!this.selectedDriver) {
        this.driverTouched = true;
        this._snackBar.open('Please select a driver before proceeding', 'X', { duration: 3000 });
        return;
      }

      const wbs = this.data?.activationId ?? this.data?.projectId ?? '';
      const DRComment: any = {
        wbs          : wbs,
        driverCode   : this.selectedDriverLabel,
        driverComment: this.driverComment ?? ''
      };
      console.log("DRComment",DRComment)
      this.service.setDRcomment(DRComment);

      this.dialogRef.close({
        confirmed: true,
        projectid: wbs,
        driverId : this.selectedDriver,
        comment  : this.driverComment ?? ''
      });
      return;
    }
    this.dialogRef.close(true);
  }
}